import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import fs from '@/components/atoms/Fieldset';
import { Button } from '@/components/ui/button';
import useUser from '@/hooks/useUser';

import emailImage from './invitation-email.png';

const InvitationsEmpty = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const email = user?.email ?? '';

  const handleCopy = () => {
    navigator.clipboard.writeText(email);
    toast.success(t('common.copied'));
  };

  return (
    <fs.Fieldset>
      <div className="flex items-center gap-4">
        <img src={emailImage} alt="" className="h-10 shrink-0" />
        <div className="flex-1">
          <div className="text-base leading-6 font-semibold text-foreground">
            {t('invitations.need_access')}
          </div>
          <div className="text-sm leading-5 text-foreground-muted">
            {t('invitations.empty_subtitle')}
            <br />
            {email}
          </div>
        </div>
        <Button variant="secondary" size="sm" onClick={handleCopy}>
          {t('common.copy')}
        </Button>
      </div>
    </fs.Fieldset>
  );
};

export default InvitationsEmpty;
